<div class="clear-row wide">
  <span class="lx-title">{{ cohort.name }}</span>
  <i
    class="lx-icon lx-close-x"
    style="cursor: pointer"
    (click)="close()"></i>
</div>

<div class="clear-row wide">
  <div class="clear-row extra-space">
    <dcc-cohort-status-indicator
      [status]="cohort.status"></dcc-cohort-status-indicator>
    <button
      *ngIf="cohort.hasPendingApproval"
      class="lx-btn-small lx-btn-negative"
      (click)="reviewChanges()">
      Review
    </button>
  </div>

  <div
    *ngIf="cohort.name !== 'Full Fleet'"
    class="clear-row extra-space">
    <button
      *renderingPermissionDirective="['ModuleUpdateAdmin']"
      class="lx-btn-small lx-btn-negative"
      (click)="deleteCohort()">
      <span>Delete</span>
    </button>
    <ng-container *ngIf="cohort?.type !== 'System'">
      <button
        *ngIf="!cohort.awaitingCreationApproval"
        class="lx-btn-small lx-btn-negative"
        (click)="toggleEnabledStatus()">
        {{ cohort.disabledDate ? 'Enable' : 'Disable' }}
      </button>
      <button
        class="lx-btn-small lx-btn-negative"
        (click)="editCohort()">
        <span>Edit</span>
      </button>
    </ng-container>
  </div>
</div>

<div class="extra-space">
  <p class="lx-label">Description</p>
  <label class="lx-body">{{ cohort.description }}</label>
</div>

<div class="extra-space">
  <p class="lx-label">Owner</p>
  <span class="clear-row lx-body">
    <span>{{ cohort.cohortCreator }}</span>
  </span>
</div>

<div class="extra-space">
  <p class="lx-label">Creation Date</p>
  <span class="clear-row lx-body">
    <span>{{ cohort.createdDate | date: 'MMMM d, y, h:mm:ss a' }}</span>
  </span>
</div>

<div *ngIf="cohort.priority" class="extra-space">
  <p class="lx-label">Priority</p>
  <span class="clear-row lx-body">
    <span>{{ cohort.priority }}</span>
  </span>
</div>

<div class="extra-space">
  <dcc-cohort-entities-details
    *ngIf="entities.length || legacyUnknownEntities.length"
    class="create-releases__phase-details"
    header="Entities"
    [entities]="entities"
    [legacyEntities]="legacyUnknownEntities"
    [setting]="
      cohort?.type === 'System' ? cohort.description : null
    "></dcc-cohort-entities-details>
</div>

<div>
  <button
    class="lx-btn-small lx-btn-secondary"
    style="width: 140px; height: 40px"
    (click)="close()">
    Close
  </button>
</div>
